<div class="section-list card card-main-section">

  <nav class="navbar navbar-expand-sm navbar-light bg-light justify-content-between section-header nav-2rows">
    <div class="section-header">
      <div class="section-icon bg-danger"><i class="fas fa-stamp"></i> Supervision Verifier</div>
      <div class="section-detail">
        <div class="section-detail-th">Verifier</div>
        <div class="section-detail-td section-detail-tit ">
          Exanter
        </div>
      </div>
    </div>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <div class="ml-auto d-flex justify-content-end">
        <ul class="nav navbar-nav ml-auto">
          <li>
            <button matTooltip="Save site basic data" type="button" class="btn btn-sm  btn-success "
              [disabled]="!isvalid||submitted" (click)="saveModel()">
              <i class="far fa-save"></i> Save
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>


  <div class="card-body">
    <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
    <app-frms-messagebar #frmsmessagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>

    <blockquote class="blockquote">
      <p class="mb-0">Exanter is our certified partner for supervisions. Please select the sites
        availables for supervisions. </p>
    </blockquote>
    <div class="row">
      <div class="col-md-5">
        <app-verifier-sites-list #sitesAsigned [company_external]="company_external"></app-verifier-sites-list>
      </div>
    </div>
  </div>
</div>